import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type PasswordResetRequestFailedAction = {
	type: 'PASSWORD_RESET_REQUEST_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): PasswordResetRequestFailedAction => ({
	type: 'PASSWORD_RESET_REQUEST_FAILED',
	payload,
});
